var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m_chart",style:(_vm.style)},[_c('div',{staticClass:"main",attrs:{"id":_vm.chartId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }